import { render, staticRenderFns } from "./ViewRelatorioRecebimento.vue?vue&type=template&id=ac045486&scoped=true"
import script from "./ViewRelatorioRecebimento.vue?vue&type=script&lang=ts"
export * from "./ViewRelatorioRecebimento.vue?vue&type=script&lang=ts"
import style0 from "./ViewRelatorioRecebimento.vue?vue&type=style&index=0&id=ac045486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac045486",
  null
  
)

export default component.exports